import { render } from "./FormularioOrdenEntrega.vue?vue&type=template&id=a68edc72&scoped=true"
import script from "./FormularioOrdenEntrega.vue?vue&type=script&lang=js"
export * from "./FormularioOrdenEntrega.vue?vue&type=script&lang=js"

import "./FormularioOrdenEntrega.vue?vue&type=style&index=0&id=a68edc72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68edc72"]])

export default __exports__